import { gsap } from 'gsap';

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
// Animate the bubbles "counter" counting up
document.querySelectorAll('.stat').forEach((el) => {
  const number = el.querySelector('.stat__number');

  gsap.from(number, {
    scrollTrigger: number,
    textContent: 0,
    duration: 3,
    delay: 0.2,
    ease: 'expo.out',
    snap: { textContent: 1 },

    stagger: {
      onUpdate: function () {
        this.targets()[0].innerHTML = numberWithCommas(
          Math.ceil(this.targets()[0].textContent)
        );
      },
    },
    // modifiers: {
    //   innerText: function (innerText) {
    //     return gsap.utils
    //       .snap(1, innerText)
    //       .toString()
    //       .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    //   },
    // },
  });
});
